<template>
  <div :style="contain">
    <b-carousel :style="contain" indicators>
      <b-carousel-slide
        v-for="(image, index) in images"
        :img-src="image.src"
        :img-alt="image.label"
        @click.native="display(image)"
        :key="`carousel_${index}`"
        style="cursor: pointer"
      />
    </b-carousel>
    <b-modal v-model="showModal" hide-footer hide-header content-class="expand-internal">
      <img :src="activeImage.src" :alt="activeImage.label" id="activeImage" />
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      activeImage: {},
      showModal: false,
      mH: 0,
      contain: {
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        minHeight: this.width + 'px',
        maxHeight: this.width + 'px',
      },
    };
  },
  methods: {
    display(image) {
      this.activeImage = image;
      this.showModal = true;
    },
  },
};
</script>

<style scoped>
::v-deep #expand-image-modal {
  justify-content: center;
  align-content: center;
  flex-direction: row;
  border-width: 0;
}

::v-deep .expand-internal {
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0);
  border-width: 0;
  box-shadow: none;
  height: 100% !important;
  width: 100% !important;
}

::v-deep #epxandedImg {
  height: 90vh;
  width: 'auto';
}

::v-deep .carousel-control-next,
::v-deep .carousel-control-prev

/*, .carousel-indicators */ {
  filter: invert(100%);
}

::v-deep .carousel-indicators li {
  background-color: #171717;
  box-shadow: inset 1px 1px 1px 1px rgba(0, 0, 0, 0.5);
}

::v-deep .carousel-indicators .active {
  background-color: black;
}

@media only screen and (max-width: 600px) {
  ::v-deep #epxandedImg {
    height: auto;
    width: 100%;
  }
}
</style>
